import React, { useState, useEffect } from "react";
import SimpleTableHeader from "../../../../components/Tables/SimpleTableHeader";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";

// material-ui
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search } from "../../../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";

const ViewECsForThisAgency = ({ id }) => {
  const { logout } = StaffuseAuth();

  const [ECs, setECs] = useState([]);

  useEffect(() => {
    if (id !== "AddAgency") {
      Get_limited_Choose_Fields_From_MongoDB_With_Search(
        "IP",
        "EC",
        { "MetaData.Agency_id": id },
        1000,
        setECs,
        {
          _id: 1,
          "BasicInfo.First_Name": 1,
          "BasicInfo.Last_Name": 1,
          "BasicInfo.Email": 1,
          "BasicInfo.Number": 1,
          "MetaData.Agency_id": 1,
        },
        logout
      );
    }
  }, []);
  console.log("ECs", ECs);

  //---------------------------------Components---------------------------------
  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        maxWidth: "95%",
        maxHeight: "800px",
        flexGrow: 1,
        p: 1,
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Typography variant="h6" gutterBottom>
          View EC's
        </Typography>
        {id === "AddAgency" ? (
          <></>
        ) : (
          <Link
            to={`/Staff/ViewEC/AddEC/${id}`}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <button>Add EC</button>
          </Link>
        )}
      </Box>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          margin: "0 auto",
          overflow: "auto",
        }}
      >
        <Table
          aria-label="simple table"
          sx={{
            border: "1px solid #e0e0e0",
            tableLayout: "fixed",
          }}
        >
          <TableHead>
            <TableRow>
              {SimpleTableHeader("Agency_id")}
              {SimpleTableHeader("_id")}
              {SimpleTableHeader("First Name")}
              {SimpleTableHeader("Last Name")}
              {SimpleTableHeader("Email")}
              {SimpleTableHeader("Number")}
            </TableRow>
          </TableHead>
          <TableBody>
            {ECs.map((EC, index) => (
              <TableRow
                key={EC._id}
                sx={{
                  "&:hover": {
                    backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                    "& .MuiTableCell-root": {
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word", // Adjust padding here to make cells smaller
                    },
                  },
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {EC.MetaData && EC.MetaData["Agency_id"]}
                </TableCell>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {EC && EC["_id"]}
                </TableCell>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {EC.BasicInfo && EC.BasicInfo["First_Name"]}
                </TableCell>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {EC.BasicInfo && EC.BasicInfo["Last_Name"]}
                </TableCell>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {EC.BasicInfo && EC.BasicInfo["Email"]}
                </TableCell>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {EC.BasicInfo && EC.BasicInfo["Number"]}
                </TableCell>

                {/* New TableCell for update action using Link */}
                <TableCell
                  align="left"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  <Link
                    to={`/Staff/ViewEC/${EC._id}/${EC.MetaData.Agency_id}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <button>View</button>
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ViewECsForThisAgency;
